enum Urls {
    mapJS = "https://sdk.woosmap.com/map/map.js",
    widgetJS = "https://sdk.woosmap.com/map/widgets.js",
    lambdaExternal = "https://t0a2tbeh90.execute-api.eu-west-1.amazonaws.com/default/woosmap-service-sdm-id",
    favMarkerUrl = "https://indoor.woosmap.com/salone-del-mobile/assets/Pin-to-be-visted@3x.png",
    vistedShop = "https://indoor.woosmap.com/salone-del-mobile/assets/Pin.png",
    waypoints = "https://indoor.woosmap.com/salone-del-mobile/assets/stops"
}

export default Urls;
